export default __webpack_public_path__ + "static/media/214.1c3373ad.gif";